import { Locale } from '@fluidx/utilities';
import { FluidErrorInfo } from '../ErrorInfo';
import { getDialogMessagingForError } from '../ErrorDialog';

export interface EmbedMessagingStrings {
  /** Lead, bolded text of the embed messaging */
  embedTitle: string;

  /** A user friendly error message */
  embedMessage: string;
}

export interface EmbedErrorInfo extends FluidErrorInfo {
  embedStrings: EmbedMessagingStrings;
}

/**
 * Inspects a given error to determine potential fluid error type and
 * select appropriate localized string for embed error ux
 * @param error office web host or driver error
 * @param locale Host locale
 * @returns Promise to EmbedErrorInfo
 */
export async function getEmbedMessagingForError(error: unknown, locale: Locale): Promise<EmbedErrorInfo> {
  // Adapt dialog error messaging
  // TODO: Investigate need for separate messaging for embed error experiences
  const { errorType, dialogStrings } = await getDialogMessagingForError(error, locale);

  return Promise.resolve({
    errorType,
    embedStrings: {
      embedTitle: dialogStrings.dialogTitle,
      embedMessage: dialogStrings.dialogMessage
    }
  });
}
